<script>
    import { onMount } from 'svelte';
    import { darkMode } from '../../service/store.js';
    import { MoonSolid, SunSolid } from 'flowbite-svelte-icons';
    import { Button } from 'flowbite-svelte';


    let mounted = false;

    onMount(() => {
        mounted = true;
        // Disable dark mode on root path
        if (window.location.pathname === '/') {
            darkMode.set(false);
            updateTheme(false);
        } else {
            // Apply initial theme for other paths
            updateTheme($darkMode);
        }
    });

    function updateTheme(isDark) {
        if (typeof document !== 'undefined') {
            if (isDark) {
                document.documentElement.classList.add('dark');
                document.body.classList.add('bg-gray-900', 'text-white');
            } else {
                document.documentElement.classList.remove('dark');
                document.body.classList.remove('bg-gray-900', 'text-white');
            }
        }
    }

    function toggleDarkMode() {
        // Prevent toggling on root path
        if (window.location.pathname === '/') {
            return;
        }
        
        darkMode.update(current => {
            const newValue = !current;
            updateTheme(newValue);
            return newValue;
        });
    }

    // React to store changes
    $: if (mounted) {
        updateTheme($darkMode);
    }
</script>

<button
    class="flex items-center gap-2 px-3 py-1 rounded-full border border-gray-300 dark:border-gray-600 text-sm font-medium text-gray-700 dark:text-gray-300 hover:bg-gray-50 dark:hover:bg-gray-800 transition-colors"
    on:click={toggleDarkMode}
    data-tour="nav-darkmode"
    aria-label="Toggle dark mode"
>
    {#if $darkMode}
        <SunSolid class="w-4 h-4 text-yellow-400 dark:text-yellow-300" />
    {:else}
        <MoonSolid class="w-4 h-4 text-gray-600" />
    {/if}
</button>